import React from 'react';

// Components
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';
import WpButton from 'Wpds/components/button/WpButton';

// Hooks
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Styles
import './ItemDoesntExistError.scss';

type Props = {
  title?: string;
  description?: string;
  image?: Illustrations;
  buttonLabel?: string;
  buttonCallback?: () => void;
};

const ItemDoesntExistError = ({ title, description, image, buttonLabel, buttonCallback }: Props) => {
  const { tr } = useTranslation();
  const defaultButtonLabel = tr('perform.common.take_me_back');
  const finalButtonLabel = buttonLabel || defaultButtonLabel;
  const showTitle = !!title;
  const showDescription = !!description;
  const showButton = finalButtonLabel && buttonCallback;
  const imgSrc = image || Illustrations.person_working_from_bench_white_bg;

  const baseClassName = 'ItemDoesntExistError';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__error`}>
        <div className={`${baseClassName}__error__content`}>
          <WpIllustration className={`${baseClassName}__error__content__image`} src={imgSrc} alt={imgSrc} />
          {showTitle && <h5>{title}</h5>}
          {showDescription && <p className={`${baseClassName}__error__content__description`}>{description}</p>}
          {showButton && <WpButton onClick={buttonCallback}>{finalButtonLabel}</WpButton>}
        </div>
      </div>
    </div>
  );
};

export default ItemDoesntExistError;
